import {
  Heading,
  HStack,
  Slider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack,
  Spinner,
  Stack,
  Text,
  Tooltip,
  VStack,
} from "@chakra-ui/react";
import { BackButton, TouchableOpacity } from "components";
import { useTranslation } from "languages";
import React, { useEffect, useRef, useState } from "react";

const Radio: React.FC = () => {
  const { translation, isArabic } = useTranslation();

  const audioRef = useRef<any>(null);
  const radioScrollRef = useRef<any>(null);

  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const [isBuffering, setBuffering] = useState(false);
  const [isLoadig, setLoading] = useState(true);
  const [radioList, setRadioList] = useState<any>([]);
  const [selectedItem, setRadioItem] = useState<any>({});

  useEffect(() => {
    const fetchRadio = async () => {
      await fetch(
        `https://mp3quran.net/api/v3/radios?language=${isArabic ? "ar" : "eng"}`
      )
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);
          // console.log("=-=-=-=", res?.radios)
          if (res?.radios && res?.radios.length > 0) {
            setRadioList(res?.radios);
            // setTimeout(() => {
            //   setRadioItem(res?.radios[0]);
            // }, 500);
            // setTimeout(() => {
            //   setBuffering(false);
            // }, 1000);
          }
        })
        .catch((e) => {
          setLoading(false);
          console.log("=-=-=-=-=", e);
        });
    };
    fetchRadio();
  }, [isArabic]);

  const togglePlayPause = () => {
    if (audioRef) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const playerStart = () => {
    if (audioRef.current) {
      audioRef.current.load(); // Reload the audio element
      audioRef.current.oncanplay = () => {
        // Play when ready
        audioRef.current.play();
        setIsPlaying(true);
      };
    }
  };

  const handleSetItem = (it: any) => {
    setBuffering(true);
    setIsPlaying(false);
    setRadioItem(it);
    setTimeout(playerStart, 1000);
  };

  const scrollToIndex = (index: number) => {
    // if (radioScrollRef.current) {
    //   radioScrollRef.current.scrollBy({
    //     left: offset,
    //     behavior: "smooth", // For smooth scrolling
    //   });
    // }

    if (radioScrollRef?.current) {
      const itemWidth = 200; // Adjust based on your radio item width
      const offset = index * itemWidth;
      radioScrollRef.current.scrollTo({
        left: offset,
        behavior: "smooth",
      });
    }
  };

  const handlePrevious = () => {
    const selectedIndex = (radioList || []).findIndex(
      (it: any) => it?.id === selectedItem?.id
    );
    if (selectedIndex > -1) {
      if (selectedIndex !== 0) {
        handleSetItem(radioList[selectedIndex - 1]);
        scrollToIndex(selectedIndex - 1);
      }
    }
  };

  const handleNext = () => {
    const selectedIndex = (radioList || []).findIndex(
      (it: any) => it?.id === selectedItem?.id
    );
    if (selectedIndex > -1) {
      if (selectedIndex < radioList.length - 1) {
        handleSetItem(radioList[selectedIndex + 1]);
        scrollToIndex(selectedIndex + 1);
      }
    }
  };

  // console.log("==-==", isBuffering);

  // const layoutDirection = useBreakpointValue({ base: "row", md: "column" });

  return (
    <Stack
      w={"100%"}
      h={"100%"}
      justify={"space-between"}
      // gap={50}
      overflowY={"auto"}
      className="mac-scrollbar"
    >
      <Stack align={"flex-start"} pt={2} px={[2, 10]}>
        <BackButton mt={2} mx={0} />
        <Heading>{translation["radio"]}</Heading>

        {isLoadig && (
          <Spinner size="xl" position={"absolute"} top={"50%"} left={"50%"} />
        )}

        {selectedItem?.url && (
          <audio
            ref={audioRef}
            src={selectedItem?.url}
            // preload="none"
            onLoadedData={() => setBuffering(true)}
            onPlaying={() => setBuffering(false)}
          />
        )}

        <Stack w={"100%"} direction={["column", "row"]}>
          <VStack
            // h={"300px"}
            justify={"center"}
            w={["100%", "35%"]}
            bgColor={"secondary.300"}
            py={[2, 10]}
            px={[2, 0]}
            rounded={"xl"}
          >
            {selectedItem?.id ? (
              <>
                <Text>{translation["now_listing"]}</Text>
                <Text
                  color={"primary.300"}
                  fontSize={"5xl"}
                  fontWeight={"bold"}
                  noOfLines={1}
                >
                  {selectedItem?.name}
                </Text>
                <Text>{translation["al_quran_radio"]}</Text>
              </>
            ) : (
              <Text
                color={"primary.300"}
                fontSize={"3xl"}
                fontWeight={"bold"}
                noOfLines={1}
              >
                {translation["not_select"]}
              </Text>
            )}
          </VStack>

          <VStack ml={[0, 10]} flex={1} align={"flex-start"} gap={5}>
            <Text fontWeight={"bold"} fontSize={"2xl"}>
              {selectedItem?.name}
            </Text>
            {/* <Text>No 2 . Verse 286 . Madaniyah</Text> */}
            <HStack w={"full"} gap={5} fontWeight={"bold"}>
              <Text>00:00</Text>
              <Slider
                aria-label="slider-ex-2"
                value={100}
                min={0}
                max={100}
                isDisabled
              >
                <SliderTrack bg="secondary.100">
                  <SliderFilledTrack bg="primary.300" />
                </SliderTrack>
                <SliderThumb bgColor={"primary.300"} />
              </Slider>
              <Text>00:00</Text>
            </HStack>

            <HStack gap={5} alignSelf={"center"} mt={[1, 5]}>
              <TouchableOpacity
                onClick={handlePrevious}
                disabled={!selectedItem?.id}
              >
                <svg
                  id="previous"
                  xmlns="http://www.w3.org/2000/svg"
                  width="34"
                  height="34"
                  viewBox="0 0 24 24"
                >
                  <g id="vuesax_bold_previous" data-name="vuesax/bold/previous">
                    <g id="previous-2" data-name="previous">
                      <path
                        id="Vector"
                        d="M24,0V24H0V0Z"
                        transform="translate(24 24) rotate(180)"
                        fill="#bf8d46"
                        opacity="0"
                      />
                      <path
                        id="Vector-2"
                        data-name="Vector"
                        d="M13.4,12.126a2.556,2.556,0,0,1-3.83,2.21l-4.15-2.39-4.15-2.4a2.544,2.544,0,0,1,0-4.41l4.15-2.4L9.575.346a2.553,2.553,0,0,1,3.83,2.21Z"
                        transform="translate(6.836 4.664)"
                        fill="#bf8d46"
                      />
                      <path
                        id="Vector-3"
                        data-name="Vector"
                        d="M0,13.11V.75A.755.755,0,0,1,.75,0,.755.755,0,0,1,1.5.75V13.11a.755.755,0,0,1-.75.75A.755.755,0,0,1,0,13.11Z"
                        transform="translate(3.012 5.07)"
                        fill="#bf8d46"
                      />
                    </g>
                  </g>
                </svg>
              </TouchableOpacity>

              <TouchableOpacity
                bgColor="#5F4C31"
                h={"70px"}
                w={"70px"}
                align={"center"}
                justify={"center"}
                borderRadius={100}
                onClick={togglePlayPause}
                disabled={!selectedItem?.id}
              >
                {isBuffering ? (
                  <Spinner />
                ) : (
                  <>
                    {isPlaying ? (
                      <svg
                        id="pause"
                        xmlns="http://www.w3.org/2000/svg"
                        width="34"
                        height="34"
                        viewBox="0 0 24 24"
                      >
                        <g id="vuesax_bulk_pause" data-name="vuesax/bulk/pause">
                          <g id="pause-2" data-name="pause">
                            <path
                              id="Vector"
                              d="M7.65,1.89C7.65.54,7.08,0,5.64,0H2.01C.57,0,0,.54,0,1.89V16.11C0,17.46.57,18,2.01,18H5.64c1.44,0,2.01-.54,2.01-1.89Z"
                              transform="translate(3 3)"
                              fill="#bf8d46"
                            />
                            <path
                              id="Vector-2"
                              data-name="Vector"
                              d="M7.65,1.89C7.65.54,7.08,0,5.64,0H2.01C.58,0,0,.54,0,1.89V16.11C0,17.46.57,18,2.01,18H5.64c1.44,0,2.01-.54,2.01-1.89Z"
                              transform="translate(13.35 3)"
                              fill="#bf8d46"
                            />
                            <path
                              id="Vector-3"
                              data-name="Vector"
                              d="M24,0V24H0V0Z"
                              fill="#bf8d46"
                              opacity="0"
                            />
                          </g>
                        </g>
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 15.812 16.822"
                      >
                        <path
                          id="Vector"
                          d="M0,4.97C0,.527,3.14-1.264,6.978.946L9.956,2.667l2.977,1.721c3.838,2.21,3.838,5.839,0,8.048L9.956,14.158,6.978,15.88C3.14,18.09,0,16.275,0,11.856V4.97Z"
                          fill="#bf8d46"
                        />
                      </svg>
                    )}
                  </>
                )}
              </TouchableOpacity>

              <TouchableOpacity
                onClick={handleNext}
                disabled={!selectedItem?.id}
              >
                <svg
                  id="next"
                  xmlns="http://www.w3.org/2000/svg"
                  width="34"
                  height="34"
                  viewBox="0 0 24 24"
                >
                  <g id="vuesax_bold_next" data-name="vuesax/bold/next">
                    <g id="next-2" data-name="next">
                      <path
                        id="Vector"
                        d="M24,0V24H0V0Z"
                        transform="translate(24 24) rotate(180)"
                        fill="#bf8d46"
                        opacity="0"
                      />
                      <path
                        id="Vector-2"
                        data-name="Vector"
                        d="M0,12.126a2.556,2.556,0,0,0,3.83,2.21l4.15-2.39,4.15-2.4a2.544,2.544,0,0,0,0-4.41l-4.15-2.4L3.83.346A2.553,2.553,0,0,0,0,2.556Z"
                        transform="translate(3.762 4.664)"
                        fill="#bf8d46"
                      />
                      <path
                        id="Vector-3"
                        data-name="Vector"
                        d="M0,13.11V.75A.755.755,0,0,1,.75,0,.755.755,0,0,1,1.5.75V13.11a.75.75,0,0,1-1.5,0Z"
                        transform="translate(19.488 5.07)"
                        fill="#bf8d46"
                      />
                    </g>
                  </g>
                </svg>
              </TouchableOpacity>
            </HStack>
          </VStack>
        </Stack>
      </Stack>

      <VStack align={"self-start"} pt={2}>
        <Heading px={[2, 10]}>{translation["popular_radio"]}</Heading>

        <HStack
          overflowX={"auto"}
          className="mac-scrollbar"
          gap={5}
          h={"full"}
          w={"100%"}
          ref={radioScrollRef}
        >
          {radioList.map((item: any, index: number) => {
            const selected = selectedItem?.id === item?.id;
            return (
              <TouchableOpacity
                key={index}
                bgColor={selected ? "primary.300" : "secondary.300"}
                // h={"full"}
                h={"180px"}
                w={"180px"}
                justify={"center"}
                align={"center"}
                rounded={"xl"}
                border={"1px solid var(--chakra-colors-primary-300)"}
                gap={5}
                onClick={() => handleSetItem(item)}
              >
                <svg
                  id="external-drive"
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    id="vuesax_twotone_external-drive"
                    data-name="vuesax/twotone/external-drive"
                  >
                    <g id="external-drive-2" data-name="external-drive">
                      <path
                        id="Vector"
                        d="M5,20a4.724,4.724,0,0,1-5-5V5A4.724,4.724,0,0,1,5,0h7a4.724,4.724,0,0,1,5,5V15a4.724,4.724,0,0,1-5,5Z"
                        transform="translate(4 2)"
                        fill="none"
                        stroke={
                          selected
                            ? "var(--chakra-colors-secondary-900)"
                            : "#ecdfc9"
                        }
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                        stroke-dasharray="0 0"
                      />
                      <path
                        id="Vector-2"
                        data-name="Vector"
                        d="M0,0H17"
                        transform="translate(4 15)"
                        fill="none"
                        stroke={
                          selected
                            ? "var(--chakra-colors-secondary-900)"
                            : "#ecdfc9"
                        }
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                        stroke-dasharray="0 0"
                      />
                      <path
                        id="Vector-3"
                        data-name="Vector"
                        d="M0,0H1"
                        transform="translate(7 12)"
                        fill="none"
                        stroke={
                          selected
                            ? "var(--chakra-colors-secondary-900)"
                            : "#ecdfc9"
                        }
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                        stroke-dasharray="0 0"
                      />
                      <path
                        id="Vector-4"
                        data-name="Vector"
                        d="M0,0H1"
                        transform="translate(7 9.5)"
                        fill="none"
                        stroke={
                          selected
                            ? "var(--chakra-colors-secondary-900)"
                            : "#ecdfc9"
                        }
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                        stroke-dasharray="0 0"
                      />
                      <path
                        id="Vector-5"
                        data-name="Vector"
                        d="M0,0H1"
                        transform="translate(7 7)"
                        fill="none"
                        stroke={
                          selected
                            ? "var(--chakra-colors-secondary-900)"
                            : "#ecdfc9"
                        }
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                        stroke-dasharray="0 0"
                      />
                      <path
                        id="Vector-6"
                        data-name="Vector"
                        d="M24,0V24H0V0Z"
                        fill="none"
                        opacity="0"
                      />
                      <path
                        id="Vector-7"
                        data-name="Vector"
                        d="M.495.5H.5"
                        transform="translate(16 17.75)"
                        fill="none"
                        stroke={
                          selected
                            ? "var(--chakra-colors-secondary-900)"
                            : "#ecdfc9"
                        }
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        stroke-dasharray="0 0"
                      />
                    </g>
                  </g>
                </svg>

                <Tooltip label={item?.name} hasArrow>
                  <Text
                    w={"180px"}
                    textAlign={"center"}
                    noOfLines={1}
                    color={selected ? "secondary.900" : "primary.300"}
                    fontSize={"xl"}
                    fontWeight={"bold"}
                  >
                    {item?.name}
                  </Text>
                </Tooltip>
              </TouchableOpacity>
            );
          })}
        </HStack>
      </VStack>
    </Stack>
  );
};

export default Radio;
